"use strict";
import "src/decidim/participatory_documents/skip_cookie_warning.js";
